<h1 mat-dialog-title>{{'COMMON.LABEL.PRINT' | translate}}</h1>

<ng-container [formGroup]="printForm">

  <div mat-dialog-content>
    @if (printForm) {
      <section>
        <mat-radio-group formControlName="layout"
          class="row">
          <div class="col-auto d-flex flex-column">
            @if (dialogData.actions.includes(ePrintType.DETAILS)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.DETAILS"
                >{{'COMMON.LABEL.DETAILS' | translate}}
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.LIST)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.LIST"
                >{{'COMMON.LABEL.LIST' | translate}}
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.LABEL)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.LABEL"
                >{{'COMMON.LABEL.LABEL' | translate}}
              </mat-radio-button>
            }
          </div>
          <div class="col-auto d-flex flex-column">
            @if (dialogData.actions.includes(ePrintType.GRID_1)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.GRID_1"
                >
                1x1 (1 {{'COMMON.LABEL.ITEMS' | translate}})
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.GRID_2_LANDSCAPE)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.GRID_2_LANDSCAPE"
                >
                2x1 (2 {{'COMMON.LABEL.ITEMS' | translate}})
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.GRID_2)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.GRID_2"
                >
                2x3 (6 {{'COMMON.LABEL.ITEMS' | translate}})
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.GRID_3)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.GRID_3"
                >
                3x3 (9 {{'COMMON.LABEL.ITEMS' | translate}})
              </mat-radio-button>
            }
          </div>
          <div class="col-auto d-flex flex-column">
            @if (dialogData.actions.includes(ePrintType.LOAN_LIST)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.LOAN_LIST"
                >{{'COMMON.LABEL.LOAN_LIST' | translate}}
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.LOAN_DELIVERY_NOTE)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.LOAN_DELIVERY_NOTE"
                >
                {{'COMMON.LABEL.LOAN_DELIVERY_NOTE' | translate}}
              </mat-radio-button>
            }
          </div>
          <div class="col-auto d-flex flex-column">
            @if (dialogData.actions.includes(ePrintType.SALE_LIST)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.SALE_LIST"
                >{{'COMMON.LABEL.SALE_LIST' | translate}}
              </mat-radio-button>
            }
            @if (dialogData.actions.includes(ePrintType.SALE_DELIVERY_NOTE)) {
              <mat-radio-button color="primary"
                [value]="ePrintType.SALE_DELIVERY_NOTE"
                >
                {{'COMMON.LABEL.SALE_DELIVERY_NOTE' | translate}}
              </mat-radio-button>
            }
          </div>
        </mat-radio-group>
        @if (printForm.get('layout').value === ePrintType.LABEL) {
          <mat-form-field appearance="outline"
            class="mt-2"
            >
            <mat-label>{{'PRINT.SKIP_N_OF_LABELS' | translate}}</mat-label>
            <input matInput
              formControlName="skipNumberOfLabels"
              type="number">
          </mat-form-field>
        }
      </section>
    }
  </div>

  <div mat-dialog-actions
    class="d-flex justify-content-between align-items-end">
    <div class="flex-1">
      @if (dialogData.title && printForm.get('layout').value !== ePrintType.LABEL) {
        <mat-checkbox
          class="mr-2"
          color="primary"
        formControlName="showTitle">{{'PRINT.PRINT_TITLE' | translate}}</mat-checkbox>
      }

      @if (uiRoleManagerService.canI(eRoleActions.VIEW_VALUE) && printForm.get('layout').value !== ePrintType.LOAN_LIST && printForm.get('layout').value !== ePrintType.LOAN_DELIVERY_NOTE && printForm.get('layout').value !== ePrintType.SALE_LIST && printForm.get('layout').value !== ePrintType.SALE_DELIVERY_NOTE && printForm.get('layout').value !== ePrintType.LABEL) {
        <mat-checkbox
          class="mr-2"
          color="primary"
        formControlName="showValue">{{'PRINT.PRINT_VALUE' | translate}}</mat-checkbox>
      }

      @if (printForm.get('layout').value === ePrintType.GRID_1 || printForm.get('layout').value === ePrintType.GRID_2_LANDSCAPE || printForm.get('layout').value === ePrintType.GRID_2 || printForm.get('layout').value === ePrintType.GRID_3) {
        <mat-checkbox color="primary"
        formControlName="showNote">{{'PRINT.PRINT_NOTE' | translate}}</mat-checkbox>
        <mat-checkbox color="primary"
        formControlName="showTypologies">{{printTypologyLabel | translate}}</mat-checkbox>
      }

      @if (printForm.get('layout').value === ePrintType.LABEL) {
        <mat-checkbox
          class="mr-2"
          color="primary"
        formControlName="showImg">{{'PRINT.PRINT_IMG' | translate}}</mat-checkbox>
      }

      @if (printForm.get('layout').value === ePrintType.GRID_1) {
        <mat-checkbox
          class="mr-2"
          color="primary"
        formControlName="showAllImages">{{'PRINT.PRINT_ALL_IMG' | translate}}</mat-checkbox>
      }

    </div>

    <div>
      <button mat-stroked-button
        mat-dialog-close
      color="primary">{{'BITF.LABEL.CANCEL' | translate}}</button>

      <button mat-raised-button
        color="primary"
      (click)="onPrint()">{{'COMMON.LABEL.PRINT' | translate}}</button>
    </div>
  </div>

</ng-container>